module.exports = __webpack_public_path__ + "media/assets/Checkmark-a135452360690a9ddad69d1fa877fcaf.svg";